export default {
  info: {
    articleNumber: null,
    availability: [],
    currentColor: null,
    composition: {},
    images: { front: { src: null } },
    printAreas: { front: {}, back: {}, left: {}, right: {} },
    title: null
  },
  price: undefined,
  isLoaded: false,
  export: {},
  designs: {
    back: [],
    front: [],
    left: [],
    right: []
  },
  colors: []
};
